export default function getEnv(name) {
    return window?.configuration?.[name] || process.env[name]
}